import axios from 'axios';
import { API_URL } from '../config';

// A differenza di sindacatoApi.js (funnel pubblico, anonimo), qui si usa
// l'istanza axios globale: AuthContext le attacca automaticamente
// l'header Authorization con il JWT dell'utente loggato, che il backend
// verifica tramite get_operator_user (operatore o admin).

export async function getLeads({ stato, settore, ordinaPer } = {}) {
  const params = {};
  if (stato) params.stato = stato;
  if (settore) params.settore = settore;
  if (ordinaPer) params.ordina_per = ordinaPer;
  const { data } = await axios.get(`${API_URL}/sindacato/operatore/leads`, { params });
  return data;
}

export async function getLeadDetail(leadId) {
  const { data } = await axios.get(`${API_URL}/sindacato/operatore/leads/${leadId}`);
  return data;
}

export async function aggiungiNota(leadId, testo) {
  const { data } = await axios.post(`${API_URL}/sindacato/operatore/leads/${leadId}/note`, { testo });
  return data;
}

export async function cambiaStato(leadId, stato) {
  const { data } = await axios.post(`${API_URL}/sindacato/operatore/leads/${leadId}/stato`, { stato });
  return data;
}

export async function eseguiAnalisiCcnl(leadId, ccnlId, cedolinoCcnl, data) {
  const params = data ? { data } : {};
  const res = await axios.post(
    `${API_URL}/sindacato/operatore/leads/${leadId}/analisi-ccnl/${ccnlId}`,
    cedolinoCcnl,
    { params }
  );
  return res.data;
}

export async function scaricaReportPdf(leadId) {
  const response = await axios.get(`${API_URL}/sindacato/operatore/leads/${leadId}/report.pdf`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `caso_${leadId}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function creaVersioneCcnl(payload) {
  const { data } = await axios.post(`${API_URL}/sindacato/ccnl`, payload);
  return data;
}
